import SalesTargetActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataAssign: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  showModalTarget:false,
  onSubmit:false,
  single:null,
  helperSalesTarget:null,
  salesOrderHelperFull:null,
  printSalesTarget:null
};

function SalesTargetReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
   case SalesTargetActions.RESET_LIST:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,data:{}};
    case SalesTargetActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case SalesTargetActions.NEW_DATA_TARGET:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModalTarget:true};
    case SalesTargetActions.UPDATE_DATA:
      return { ...state, isProcessing: false, single:null,isNewRecord:false};
    case SalesTargetActions.VIEW_DATA:
      return { ...state, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case SalesTargetActions.VIEW_DATA_TARGET:
      return { ...state, isProcessing: false, single:action.payload,isNewRecord:false,showModalTarget:true};
    case SalesTargetActions.RESET_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form,showModal:false,showModalTarget:false};
    case SalesTargetActions.DELETE_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case SalesTargetActions.ON_SUBMIT:
      return { ...state, onSubmit:true};
    case SalesTargetActions.SHOW_DATA:
      return { ...state,  isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case SalesTargetActions.SHOW_DATA_ASSIGN:
      return { ...state,  isError: false, dataAssign: action.payload, errorMessage: [],isProcessing:false };
    case SalesTargetActions.SUCCESS_DATA:
      return { ...state, isError: false, showModal:false,showModalTarget:false,form:INITIAL_STATE.form , onSubmit:false};
    case SalesTargetActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false,isSuccess:false};
    case SalesTargetActions.ERROR_DATA:
      return { ...state,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case SalesTargetActions.GET_HELPER_SALESTARGET:
      return { ...state, isError: false,isSuccess:false,onSubmit:false,helperSalesTarget:action.payload};
    case SalesTargetActions.GET_HELPER_SALESTARGET_FULL:
      return { ...state, isError: false,isSuccess:false,onSubmit:false,salesOrderHelperFull:action.payload};
    case SalesTargetActions.PRINT_SALESTARGET:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSalesTarget:null};
    case SalesTargetActions.PRINT_SalesTarget:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSalesTarget:action.payload};
    
    default:
      return state;
    }
}


export default SalesTargetReducer;
